import React from 'react';
import { Canvas, IText } from 'fabric';
import { Bold, Highlighter, Italic, PenLine, Underline } from 'lucide-react';
import { ToolBtn } from '../../../shared/ui/tool-btn';
import { useTextStyleField } from '../../hooks/use-text-style-field';
import { useTextHighlights } from '../../hooks/use-text-highlights';
import { TEXT_DEFAULTS } from '../../constants/text-defaults';

interface FormatControlsProps {
  textObject: IText;
  canvas: Canvas;
}

export const FormatControls: React.FC<FormatControlsProps> = ({ textObject, canvas }) => {
  const [fontWeight, setFontWeight] = useTextStyleField(textObject, canvas, 'fontWeight', TEXT_DEFAULTS.fontWeight);
  const [fontStyle, setFontStyle] = useTextStyleField(textObject, canvas, 'fontStyle', TEXT_DEFAULTS.fontStyle);
  const [underline, setUnderline] = useTextStyleField(textObject, canvas, 'underline', TEXT_DEFAULTS.underline);

  const highlights = useTextHighlights(textObject, canvas);

  return (
    <>
      <ToolBtn
        onClick={() => setFontWeight(fontWeight === 'bold' ? 'normal' : 'bold')}
        title='Bold'
        active={fontWeight === 'bold'}
      >
        <Bold size={15} />
      </ToolBtn>
      <ToolBtn
        onClick={() => setFontStyle(fontStyle === 'italic' ? 'normal' : 'italic')}
        title='Italic'
        active={fontStyle === 'italic'}
      >
        <Italic size={15} />
      </ToolBtn>
      <ToolBtn onClick={() => setUnderline(!underline)} title='Underline' active={underline}>
        <Underline size={15} />
      </ToolBtn>
      <ToolBtn
        onClick={highlights.toggleBlock}
        title='Resaltar caja completa (requiere selección)'
        active={highlights.blockActive}
      >
        <Highlighter size={15} />
      </ToolBtn>
      <ToolBtn
        onClick={highlights.toggleTight}
        title='Resaltar ajustado a la letra (requiere selección)'
        active={highlights.tightActive}
      >
        <PenLine size={15} />
      </ToolBtn>
    </>
  );
};
